export interface CategoryItem {
  id: string;
  name: string;
  shortName: string;
  description: string;
  icon: string;
  cover: string;
  accentLabel: string;
}

export const categories: CategoryItem[] = [
  {
    id: "daily",
    name: "日常记录",
    shortName: "日常",
    description: "记录平凡日子里的真实瞬间：清晨的咖啡、阳台的花草、傍晚的晚餐。这里有最贴近生活温度的片段。",
    icon: "ri-sun-line",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20minimal%20apartment%20corner%20with%20warm%20afternoon%20sunlight%20through%20sheer%20curtains%2C%20small%20potted%20plants%20and%20a%20cup%20of%20tea%2C%20soft%20warm%20orange%20palette%2C%20calm%20lifestyle%20aesthetic%2C%20realistic%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=cat-daily-01&orientation=squarish",
    accentLabel: "温度日常",
  },
  {
    id: "travel",
    name: "旅行体验",
    shortName: "旅行",
    description: "从海岛慢旅到山野徒步，用镜头带你感受不同城市的空气、光线与味道，分享真实的旅行节奏。",
    icon: "ri-flight-takeoff-line",
    cover:
      "https://readdy.ai/api/search-image?query=Scenic%20coastal%20mountain%20road%20at%20golden%20hour%20with%20sea%20in%20distance%2C%20warm%20sunset%20orange%20sky%2C%20travel%20documentary%20aesthetic%2C%20wide%20open%20landscape%2C%20realistic%20photography%2C%20rich%20warm%20tones%2C%20high%20detail&width=800&height=600&seq=cat-travel-01&orientation=squarish",
    accentLabel: "远方风景",
  },
  {
    id: "insight",
    name: "个人见解",
    shortName: "见解",
    description: "关于独处、焦虑、坚持与慢生活的一些真实思考。不灌鸡汤，只把踩过的坑和想明白的事讲给你听。",
    icon: "ri-lightbulb-line",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20reading%20nook%20with%20open%20notebook%2C%20fountain%20pen%20and%20a%20warm%20desk%20lamp%2C%20evening%20ambient%20light%2C%20thoughtful%20reflective%20mood%2C%20warm%20neutral%20tones%2C%20clean%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=cat-insight-01&orientation=squarish",
    accentLabel: "真诚思考",
  },
];